import TicketDetail from '../../../components/atoms/tickets/TicketDetail'
import FeedbackSuccess from '../../../components/atoms/feedbacks/feedback-success'
import PageHeadline from '../../../components/molecules/headlines/PageHeadline'
import MinMessage from '../../../components/molecules/messages/MinMessage'

export default {
  components: {
    TicketDetail,
    FeedbackSuccess,
    PageHeadline,
    MinMessage
  },
  data() {
    return {
      successMessage: 'ギフトURLをコピーしました',
      isShowableSuccess: false
    }
  },
  methods: {
    onClickUsableGift() {
      window.location.href = '/mypage/gifts'
    },
    onClickGiftUrl() {
      const giftUrl = document.querySelector('input.gift-code-field--inputted')
      giftUrl.select()
      const result = document.execCommand('copy')
      document.getSelection().empty()
      if (result) {
        this.isShowableSuccess = true
      }
    },
    enterSuccess() {
      setTimeout(() => {
        this.isShowableSuccess = false
      }, 3000)
    }
  }
}
